import { useEffect } from 'react'
import { Header, Footer } from '@/components/layout'
import { Hero, Services, About, Projects, Contact } from '@/components/sections'
import { Experience } from '@/components/sections/Experience'
import { Writing } from '@/components/sections/Writing'

export default function App() {
  useEffect(() => {
    if (window.location.hash) {
      const section = document.getElementById(window.location.hash.slice(1))
      section?.scrollIntoView({ behavior: 'instant' })
    } else {
      window.scrollTo(0, 0)
    }
  }, [])
  return (
    <div className="portfolio-site">
      <Header />
      <main id="main-content">
        <Hero />
        <About />
        <Experience />
        <Projects />
        <Services />
        <Writing />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}
